export default __webpack_public_path__ + "static/media/pinned.8484d9c8.svg";